import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

import { Box, CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const _token = localStorage.getItem("token");

  const [isAuthenticated, setIsAuthenticated] = useState(!!_token);
  const [token, setToken] = useState(_token);
  const [reloading, setReloading] = useState(false);

  const redirectToLogin = useCallback(() => {
    navigate("/");
    setIsAuthenticated(false);
  }, [navigate]);

  const unProtectedRoutes = useMemo(() => ["/forgetpassword", "/user/reset", "/SuccessPage", "/"], []);
  const isStoragePresent = useCallback( async () => {
    setReloading(true);
    const isUnprotectedRoute = unProtectedRoutes.includes(location.pathname);
    if (
      !isUnprotectedRoute &&
      localStorage.getItem("userID") === null &&
      localStorage.getItem("token") === null
    ) {
      localStorage.clear();
      redirectToLogin();
    } else if(isUnprotectedRoute && localStorage.getItem("userID") !== null && localStorage.getItem("token") !== null){
      navigate("/home");
  } else if(isUnprotectedRoute && localStorage.getItem("userID") === null && localStorage.getItem("token") === null && !(['/forgetpassword'].includes(location.pathname) || ['/user/reset'].includes(location.pathname) )){
    navigate("/");
  }
  setReloading(false);
  }, [location.pathname, unProtectedRoutes, redirectToLogin]);

  const login = useCallback(() => {
    setIsAuthenticated(true);
  }, []);

  const doLogout = useCallback(async () => {
    try {
      redirectToLogin();
    } catch (e) {
      console.error({ e });
    }
  }, [redirectToLogin]);

  useEffect(() => {
    let mounted = true;
    
    const checkAuth = async () => {
      if (!mounted) return;
      setReloading(true);
      await isStoragePresent();
      if (mounted) setReloading(false);
    };
    
    checkAuth();
    
    return () => {
      mounted = false;
    };
  }, [isStoragePresent]);

  const value = useMemo(() => ({
    isAuthenticated,
    login,
    doLogout,
    token,
    redirectToLogin,
  }), [isAuthenticated, login, doLogout, token, redirectToLogin]);

  return (
    <AuthContext.Provider value={value}>
      {reloading ? (
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress style={{ color: "black" }} />
        </Box>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
